import React from 'react'
import PropTypes from 'prop-types'

import { Flex, Button } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'

const Action = ({ studyVocabularyLink }) => {
  return (
    <Flex alignItems="center" display={{ _: 'none', tablet: 'flex' }}>
      <Button href={studyVocabularyLink} type="primaryAdvanced">
        {t('Study Now')}
      </Button>
    </Flex>
  )
}

Action.propTypes = {
  studyVocabularyLink: PropTypes.string.isRequired,
}

export default Action
